export default function() {
  $('a[data-parent-page]').each((i, el) => {
    if (!localStorage) {
      return;
    }
    const $el = $(el);

    $el.on('click', (e) => {
      localStorage.setItem('parent-page', $el.attr('data-parent-page'));
    });
  });

  const $breadcrumbParent = $('.breadcrumb-item-parent a');
  if ($breadcrumbParent.length > 0) {
    if (!localStorage) {
      return;
    }
    const parentPage = localStorage.getItem('parent-page');
    const href = $breadcrumbParent.attr('href');

    if (parentPage) {
      localStorage.removeItem('parent-page');
      $breadcrumbParent.attr('href', `${href}page/${parentPage}`);
    }
  }
}
